'use strict';

import '@stimulus/polyfills'
import { Application } from 'stimulus'
import whatInput from 'what-input'

import AnchorController from './controllers/anchor_controller'
import ArticleCarouselController from './controllers/articleCarousel_controller'
import CarouselController from './controllers/carousel_controller'
import DateController from './controllers/date_controller'
import FitImageController from './controllers/fitImage_controller'
import GlitchController from './controllers/glitch_controller'
import HeroController from './controllers/hero_controller'
import HeroCarouselController from './controllers/heroCarousel_controller'
import MainController from './controllers/main_controller'
import MaskImageController from './controllers/maskImage_controller'
import MenuController from './controllers/menu_controller'
import TabController from './controllers/tab_controller'

const application = Application.start()
application.register('anchor', AnchorController)
application.register('articleCarousel', ArticleCarouselController)
application.register('carousel', CarouselController)
application.register('date', DateController)
application.register('fitImage', FitImageController)
application.register('glitch', GlitchController)
application.register('hero', HeroController)
application.register('heroCarousel', HeroCarouselController)
application.register('main', MainController)
application.register('maskImage', MaskImageController)
application.register('menu', MenuController)
// application.register('tab', TabController)
